module.exports = __webpack_public_path__ + "img/closed.f3559572.png";